import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";

// Heroicons
// Heroicons
import {
  ChatBubbleOvalLeftEllipsisIcon,
  AcademicCapIcon,
  VideoCameraIcon,
  UserGroupIcon,
  SparklesIcon,
  BuildingOffice2Icon,
  MegaphoneIcon,
  BriefcaseIcon,
} from "@heroicons/react/24/solid";

const services = [
  {
    id: "01",
    title: "Fireside Chats",
    desc: "Intimate conversations with industry leaders sharing insights, experiences, and lessons learned.",
    icon: ChatBubbleOvalLeftEllipsisIcon,
  },
  {
    id: "02",
    title: "Seminars & Workshops",
    desc: "Structured learning sessions designed to build practical knowledge and real-world skills.",
    icon: AcademicCapIcon,
  },
  {
    id: "03",
    title: "Summits & Conferences",
    desc: "Large-scale gatherings featuring thought leaders discussing trends shaping the future of work and society.",
    icon: VideoCameraIcon,
  },
  {
    id: "04",
    title: "Closed-door Briefings",
    desc: "Private, off-the-record discussions for candid exchanges and deeper strategic insights.",
    icon: UserGroupIcon,
  },
  {
    id: "05",
    title: "Leadership Circles",
    desc: "Small peer groups focused on leadership growth, mentorship, and shared learning.",
    icon: SparklesIcon,
  },
  {
    id: "06",
    title: "Investor / Founder Dialogues",
    desc: "Direct conversations between investors and founders on building, funding, and scaling impactful ventures.",
    icon: BuildingOffice2Icon,
  },
  {
    id: "07",
    title: "Youth & Talent Pathway Sessions",
    desc: "Career-focused sessions guiding students and young professionals through future opportunities and pathways.",
    icon: MegaphoneIcon,
  },
  {
    id: "08",
    title: "Leadership & Business Hangouts",
    desc: "Interactive sessions where aspiring young leaders learn directly from CEOs and industry leaders.",
    icon: BriefcaseIcon,
  },
  
];


const FourthSection = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });

  useEffect(() => {
    if (inView) controls.start("visible");
  }, [inView, controls]);

  return (
    <motion.section
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={{
        hidden: { opacity: 0, y: 50 },
        visible: {
          opacity: 1,
          y: 0,
          transition: { duration: 0.7, ease: "easeOut" },
        },
      }}
      className="w-full bg-white text-black py-14 px-6 md:py-24 lg:px-20"
    >
      {/* Header */}
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-16">
        <div>
          <h2 className="text-5xl lg:text-6xl font-semibold leading-tight">
            Our Mentorship & Networking Opportunities
          </h2>
          <p className="mt-4 text-gray-600 max-w-xl">
            Explore a wide range of events, workshops, and mentorship programs
            to advance your skills and grow your professional network.
          </p>
        </div>

        
      </div>

      {/* Services Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l">
        {services.map((service, i) => (
          <div
            key={i}
            className="border-r border-b p-10 flex flex-col items-start gap-6"
          >
            {/* Number */}
            <span className="text-sm tracking-widest text-gray-500">{service.id}</span>

            {/* Icon */}
            <service.icon className="h-10 w-10 text-[#326290] opacity-70" />

            {/* Title */}
            <h3 className="text-xl font-semibold">{service.title}</h3>

            {/* Description */}
            <p className="text-gray-500 text-sm max-w-[90%]">{service.desc}</p>
          </div>
        ))}
      </div>
    </motion.section>
  );
};

export default FourthSection;
